import * as React from "react";
import { MarginT } from "@talentpair/types/misc";
import { getMarginStyle } from "../utils";

export type HandlerProps = {
  onFocusCapture: () => void;
  onBlurCapture: () => void;
};
export interface PropsT {
  render: (hasFocus: boolean, handlers: HandlerProps) => React.ReactNode;
  margin?: MarginT;
  className?: string;
  noWrapper?: boolean;
}
interface StateT {
  hasFocus: boolean;
}

class HasFocus extends React.Component<PropsT, StateT> {
  static defaultProps: { margin: MarginT } = { margin: "normal" };
  state = { hasFocus: false };
  handlers = {
    onFocusCapture: (): void => this.setState({ hasFocus: true }),
    onBlurCapture: (): void => this.setState({ hasFocus: false }),
  };

  render(): React.ReactNode {
    const { render, margin, noWrapper, ...props } = this.props;

    return noWrapper ? (
      render(this.state.hasFocus, this.handlers)
    ) : (
      <div
        onFocusCapture={this.handlers.onFocusCapture}
        onBlurCapture={this.handlers.onBlurCapture}
        style={getMarginStyle(margin)}
        {...props}
      >
        {render(this.state.hasFocus, this.handlers)}
      </div>
    );
  }
}

export default HasFocus;
